import Modal from 'shared/components/Modal'

import './styles.scss'

class Secure3dFormModal extends Component {
    componentDidMount() {
        const { body } = this.props

        const iframeContent =
            this.iframe.contentWindow || this.iframe.contentDocument.document || this.iframe.contentDocument
        iframeContent.document.open()
        iframeContent.document.write(body)
        iframeContent.document.close()
    }

    render() {
        const { notifyOfSecure3DClosed } = window

        return (
            <Modal className="secure3d" header="Secure 3D" onClose={notifyOfSecure3DClosed}>
                <iframe
                    id="secure3d-frame"
                    ref={ifr => {
                        this.iframe = ifr
                    }}
                />
            </Modal>
        )
    }
}

export default Secure3dFormModal
